import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LANGS, pageSlugs, DEFAULT_LANG } from "@/i18n/translations";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Mechanical from "@/pages/Mechanical";
import Tires from "@/pages/Tires";
import Contact from "@/pages/Contact";

const PAGES = {
  home: Home,
  mechanical: Mechanical,
  tires: Tires,
  about: About,
  contact: Contact,
};

// Build a flat list of localized routes.
const routes = [];
LANGS.forEach((lang) => {
  Object.keys(PAGES).forEach((pageKey) => {
    const slug = pageSlugs[pageKey][lang];
    const path = slug ? `/${lang}/${slug}` : `/${lang}`;
    const Page = PAGES[pageKey];
    routes.push({ path, element: <Layout lang={lang} pageKey={pageKey}><Page /></Layout> });
  });
});

function App() {
  return (
    <div className="App light">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
          {routes.map((r) => (
            <Route key={r.path} path={r.path} element={r.element} />
          ))}
          <Route path="*" element={<Navigate to={`/${DEFAULT_LANG}`} replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
